export default __webpack_public_path__ + "static/media/cbt.6950d373.png";